import React, { Dispatch, useEffect } from 'react';
import { Col, Row, Collapse, Form, Input } from 'antd';
import { Action } from 'typesafe-actions';
import { useDispatch, useSelector } from 'react-redux';
import FilterContainer from '../../../../components/FilterContainer';
import { ApplicationState } from '../../../../store';
import {
  cleanStateMotorista,
  loadRequest,
  filter as loadFilter,
} from '../../../../store/ducks/motorista/actions';
import CollapseTitle from '../../../../components/TitleCollapseFilter';
import FilterBtn from '../../../../components/FilterBtn';
import ClearFilterBtn from '../../../../components/ClearFilterBtn';
import CollapseFilter from '../../../../components/CollapseFilter';
import TextFilter from '../../../../components/TextFilter';

const { Panel } = Collapse;

const Filter: React.FC = () => {
  const pagination = useSelector((state: ApplicationState) => state.Motorista.pagination);
  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth.inscricaoAtiva);
  const cddAtivo = useSelector((state: ApplicationState) => state.auth.cddAtivo);
  const dispatch = useDispatch<Dispatch<Action>>();

  useEffect(() => {
    const controller = new AbortController();
    if (inscricaoAtiva?.length > 0) {
      return dispatch(loadRequest(inscricaoAtiva));
    }
    return () => {
      controller.abort();
    };
  }, [dispatch, inscricaoAtiva, cddAtivo]);

  const onFilter = (values: any) => {
    const { nome, cpf } = values;
    const cpfCleaned = cpf?.replace(/[^\d]+/g, '');
    const filter = {
      nome,
      cpf: cpfCleaned,
    };
    loadFilter(filter);
    localStorage.setItem(window.location.pathname + 'valuesFilter', JSON.stringify(filter));
    dispatch(loadRequest(inscricaoAtiva, filter, pagination));
  };

  const clearFilter = () => {
    dispatch(cleanStateMotorista());
    dispatch(loadRequest(inscricaoAtiva));
    localStorage.removeItem(window.location.pathname + `valuesFilter`);
  };

  const localStorageItensPersist: string = JSON.parse(
    localStorage.getItem(window.location.pathname + `valuesFilter`) || '{}'
  );

  return (
    <CollapseFilter>
      <Panel header={<CollapseTitle>Filtro</CollapseTitle>} key="1">
        <FilterContainer onFilter={onFilter} initialValues={localStorageItensPersist}>
          <Row gutter={24}>
            <Col md={8} sm={24} xs={24}>
              <Form.Item name="nome" label={<TextFilter>Motorista</TextFilter>}>
                <Input placeholder="Digite o nome do motorista" />
              </Form.Item>
            </Col>
            <Col md={8} sm={24} xs={24}>
              <Form.Item name="cpf" label={<TextFilter>CPF</TextFilter>}>
                <Input placeholder="Digite o CPF do motorista" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24} justify="end">
            <Col md={6} sm={24} xs={24}>
              <ClearFilterBtn onClick={clearFilter}>Limpar filtros</ClearFilterBtn>
            </Col>
            <Col md={6} sm={24} xs={24}>
              <FilterBtn>Filtrar</FilterBtn>
            </Col>
          </Row>
        </FilterContainer>
      </Panel>
    </CollapseFilter>
  );
};

export default Filter;
